import React from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  CloseButton,
  Checkbox,
  Flex,
  Hide,
  Label,
  Button,
  Radio,
  Select,
  FormField,
  Tooltip,
  Text,
  theme
} from 'pcln-design-system'
import { Arrival, Departure, Minus, Plus } from 'pcln-icons'
import pclnExperimentation from '@pcln/experimentation'
import { Calendar } from '@pcln/date-picker'
import { AirPricedCalendar } from '@pcln/fly-date-picker'
import { TravelerSelection } from '../traveler-selection'
import moment from 'moment'
import TypeAheadContainer, { Dropdown } from '@pcln/typeahead'
import TypeAheadInput from '../type-ahead/TypeAheadInput'
import DateField from '../date-field'
import { pipe } from 'ramda'
import styled from 'styled-components'
// TODO: placeholder to move Popover to design system component
import { PopoverContainer } from '../Popover'
import ProductTypeCheckbox from './ProductTypeCheckbox'
import { CalendarWrapperBox, FindYourDealButton } from '../../shared'
import ShadowEffect from '../../shared/ShadowEffect'
import makeFeedbackAjaxCall from '../../utils/typeahead-feedback'
import { getDateRange } from '../../utils/date-helpers'
import BootstrapDataContext from '../../contexts/BootstrapDataContext'
import ConditionalRender from '../../experiments/ConditionalRender'
import {
  AIR_DISCLAIMER,
  ANALYTICS_CATEGORY,
  ANALYTICS_CATEGORY_FLIGHTS,
  CABIN_CLASSES,
  CALENDAR_POPOVER_SELECTOR,
  DRIVE,
  ECONOMY,
  FLIGHT_PRODUCT_TYPE,
  FLY,
  MULTI_DESTINATION,
  ONE_WAY,
  ROUND_TRIP,
  STAY
} from '../../constants/Constants'

const config = require('isomorphic-config')
const typeaheadFeedbackURL = config.client.typeahead.feedback.flights
const typeaheadFeedback = makeFeedbackAjaxCall(typeaheadFeedbackURL)
const SETI_DEFAULT = 'DEFAULT'
const noop = () => {}

Label.nowrap = styled(Label)`
  white-space: nowrap;
`

const Close = styled(CloseButton)`
  padding: 12px;
  height: 48px !important;
`

const TripTypeLabel = styled(Label)`
  cursor: pointer;
`

const StyledSelect = styled(Select)`
  background: ${theme.colors.white};
  cursor: pointer;
`

const StyledButtonContainer = styled(Box)`
  position: relative;
`

const StyledCancelCopy = styled(Box)`
  margin-top: 8px;
  position: ${props => props.isRoundTrip ? 'absolute' : undefined};
`
class FlightsSearchForm extends React.Component {
  static contextType = BootstrapDataContext

  static propTypes = {
    // todo: update to match expected shape
    // this is loosely based on the flights form in d-home
    onChange: PropTypes.func,
    onFlightChange: PropTypes.func,
    onTravelerChange: PropTypes.func,
    handleCabinClassChange: PropTypes.func,
    handleProductTypeChange: PropTypes.func,
    handleFormFocus: PropTypes.func,
    handleFormBlur: PropTypes.func,
    onTypeaheadUpdate: PropTypes.func,
    onTypeaheadSelection: PropTypes.func,
    onAddFlight: PropTypes.func,
    onRemoveFlight: PropTypes.func,
    onSubmit: PropTypes.func,
    update: PropTypes.func,
    openCalendar: PropTypes.func,
    closeCalendar: PropTypes.func,
    calendarOpen: PropTypes.func,
    handleCalendarChange: PropTypes.func,
    handleCalendarOnFocus: PropTypes.func,
    handleOnFocus: PropTypes.func,
    handleProductFocus: PropTypes.func,
    handleFlightSwap: PropTypes.func,
    handleFlightSwapChange: PropTypes.func,
    handleTravelerSelectionOnFocus: PropTypes.func,
    tripType: PropTypes.string,
    flights: PropTypes.array,
    adultsCount: PropTypes.number,
    youthsCount: PropTypes.number,
    infantsCount: PropTypes.number,
    childrenCount: PropTypes.number,
    cabinClass: PropTypes.string,
    cabinClasses: PropTypes.arrayOf(PropTypes.string),
    dropdownItems: PropTypes.array,
    recentSearches: PropTypes.array,
    productType: PropTypes.string,
    productsOptions: PropTypes.arrayOf(PropTypes.object),
    airDisclaimer: PropTypes.string,
    errors: PropTypes.object,
    role: PropTypes.string,
    ariaLabelledby: PropTypes.string,
    isFlexDates: PropTypes.bool,
    withFooter: PropTypes.bool,
    toggleRecent: PropTypes.func,
    selectedProducts: PropTypes.arrayOf(PropTypes.string),
    productTypes: PropTypes.array,
    roomCount: PropTypes.number
  }

  static defaultProps = {
    onChange: noop,
    onTravelerChange: noop,
    handleCabinClassChange: noop,
    onTypeaheadUpdate: noop,
    onAddFlight: noop,
    onRemoveFlight: noop,
    handleFormFocus: noop,
    handleFormBlur: noop,
    openCalendar: noop,
    onSubmit: noop,
    onTypeaheadSelection: noop,
    closeCalendar: noop,
    update: noop,
    tripType: ROUND_TRIP,
    flights: [{}],
    adultsCount: 1,
    youthsCount: 0,
    childrenCount: 0,
    infantsCount: 0,
    cabinClass: ECONOMY,
    productType: FLY,
    isFlexDates: false,
    selectedProducts: [FLY],
    // constants
    cabinClasses: CABIN_CLASSES,
    airDisclaimer: AIR_DISCLAIMER,
    handleOnFocus: noop,
    handleCalendarOnFocus: noop,
    handleProductFocus: noop,
    handleTravelerSelectionOnFocus: noop,
    withFooter: true,
    errors: {},
    toggleRecent: () => {}
  }

  constructor (props) {
    super(props)
    this.typeaheadWidth = [1, null, 1 / 2, null, 1 / 3]

    this.calendarInput = null
    this.destinationInput = null
  }
  componentDidMount () {
    // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
    pclnExperimentation.fireImpression('HP_LP_FLIGHTS_LARGER_INPUTS')
  }

  handleCalendarChange = ({
    i,
    isRoundTrip,
    isOneWay,
    isMultiDestination,
    dates: { startDate, endDate }
  }) => {
    const areBothDatesAvail = startDate && endDate
    const {
      onFlightChange,
      handleCalendarChange,
      update,
      closeCalendar
    } = this.props

    if (isRoundTrip) {
      onFlightChange(i, {
        departureDate: startDate,
        arrivalDate: endDate
      })

      if (handleCalendarChange) {
        handleCalendarChange({
          departureDate: startDate,
          arrivalDate: endDate
        })
      }
    } else {
      onFlightChange(i, {
        departureDate: startDate
      })

      if (handleCalendarChange) {
        handleCalendarChange({
          departureDate: startDate
        })
      }
    }

    if (isOneWay || isMultiDestination || areBothDatesAvail) {
      update(closeCalendar)
    }
  }

  handleProductTypeChange = e => {
    const type = e.target.value
    let selectedProducts
    if (e.target.checked) {
      selectedProducts = [...this.props.selectedProducts, type]
    } else {
      selectedProducts = this.props.selectedProducts.filter(
        product => product !== type
      )
    }
    const productType = selectedProducts.join(':')
    this.props.onChange({ selectedProducts, productType })
  }

  handleTripTypeChange = e => {
    const tripType = e.target.value
    this.props.onChange({ tripType })
  }

  focusCalendarInput = () => {
    if (this.calendarInput) {
      this.calendarInput.focus()
    }
  }

  focusDestinationInput = () => {
    if (this.destinationInput) {
      this.destinationInput.focus()
    }
  }

  navToNextField = (event, cb) => {
    // TODO: now that DropdownItem has an onMouseDown handler, selecting item in destination field
    // no longer focuses the calender with this.focusCalendarInput(). This is likely due to
    // a mouseup or click event that follow the mousedown, causing the onDismiss()
    // on the Calendar to trigger closeCalendar

    // preventDefault() needed because DropdownItem now uses onMouseDown vs onClick handler
    // Only preventDefault() if key isn't Tab, otherwise preventDefault() prevents tab from focusing to next field
    if (event.key !== 'Tab') {
      event.preventDefault()
    }

    const { tripType } = this.props
    const isRTorOW = tripType === ROUND_TRIP || tripType === ONE_WAY

    if (isRTorOW) {
      let isTypeAheadField

      if (cb === this.focusDestinationInput) {
        // event.currentTarget points to all three of the following:
        // the airplane icon beside each airport dropdown item
        // the airport text
        // the whitespace to the right of each item
        isTypeAheadField = event.currentTarget.id.includes('flight-departure-airport')
      } else if (cb === this.focusCalendarInput) {
        isTypeAheadField = event.currentTarget.id.includes('flight-arrival-airport')
      }

      if (isTypeAheadField && (event.key === 'Enter' || (event.type === 'mousedown' && event.button === 0))) {
        cb()
      }
    }
  }

  render () {
    const {
      onChange,
      onTravelerChange,
      handleCabinClassChange,
      onTypeaheadUpdate,
      onAddFlight,
      onRemoveFlight,
      handleFormFocus,
      handleFormBlur,
      openCalendar,
      onSubmit,
      onTypeaheadSelection,
      closeCalendar,
      update,
      tripType,
      flights,
      cabinClass,
      cabinClasses,
      dropdownItems,
      productType,
      calendarOpen,
      airDisclaimer,
      handleCalendarOnFocus,
      handleOnFocus,
      handleProductFocus,
      handleTravelerSelectionOnFocus,
      // placeholder for validation errors
      // this will also need to be updated once the container is ready
      errors = {},
      role,
      ariaLabelledby,
      withFooter,
      toggleRecent,
      selectedProducts,
      productsOptions
    } = this.props

    // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
    // TODO: AIR_HOME_CALENDAR_COLOR_RANGES clean up
    const {
      key,
      seti: {
        HP_LP_FLIGHTS_LARGER_INPUTS = SETI_DEFAULT,
        AIR_HOME_CALENDAR_COLOR_RANGES = SETI_DEFAULT
      } = {}
    } = this.context

    const isLargeInput = HP_LP_FLIGHTS_LARGER_INPUTS !== SETI_DEFAULT
    const largerInputStyle = { height: isLargeInput ? '56px' : '46px' }

    const flightDetails = {
      cabinClass,
      flights,
      tripType
    }

    const isRoundTrip = tripType === ROUND_TRIP
    const isOneWay = tripType === ONE_WAY
    const isMultiDestination = tripType === MULTI_DESTINATION
    const includesStay = productType.includes(STAY)
    const includesDrive = productType.includes(DRIVE)
    const isPackage = includesStay || includesDrive
    const showCabinClass = !isRoundTrip || !isPackage
    const visibleFlights = isMultiDestination ? flights : flights.slice(0, 1)

    const isPricedCalendarActive = isOneWay || isRoundTrip
    const CalendarComponent = isPricedCalendarActive ? AirPricedCalendar : Calendar
    // TODO: AIR_HOME_CALENDAR_COLOR_RANGES clean up
    const showPriceRangesColor = (AIR_HOME_CALENDAR_COLOR_RANGES !== SETI_DEFAULT) && !isMultiDestination

    const startLocationPlaceholder = 'Departing from?'
    const endLocationPlaceholder = 'Going to?'

    const shouldHideCalendarTooltip = (flight, i) => {
      if (
        (calendarOpen === i) ||
        ((isOneWay || isMultiDestination) && flight.departureDate) ||
        (isRoundTrip && flight.departureDate && flight.arrivalDate)
      ) {
        return true
      }
    }

    const { adultsCount, childrenCount, youthsCount, infantsCount, roomCount } = this.props
    return (
      <form id='flight-search-form' role={role} aria-labelledby={ariaLabelledby} onSubmit={onSubmit} onFocus={handleFormFocus} onBlur={handleFormBlur} >
        <Flex mb={2}>
          <Flex
            mr={3}
            alignItems='center'
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                id='trip-type-round-trip'
                name='tripType'
                aria-label='Round trip'
                checked={isRoundTrip}
                onChange={this.handleTripTypeChange}
                value={ROUND_TRIP}
              />{' '}
              Round-trip
            </TripTypeLabel>
          </Flex>
          <Flex
            mr={3}
            alignItems='center'
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                mr={1}
                id='trip-type-one-way'
                name='tripType'
                aria-label='One way'
                checked={isOneWay}
                onChange={e => {
                  this.handleTripTypeChange(e)
                }}
                value={ONE_WAY}
              />{' '}
              One-way
            </TripTypeLabel>
          </Flex>
          <Flex
            mr={3}
            alignItems='center'
          >
            <TripTypeLabel fontSize={0} fontWeight={500} nowrap>
              <Radio
                mr={1}
                id='trip-type-multi-destination'
                name='tripType'
                aria-label='Multi Destination'
                checked={isMultiDestination}
                onChange={this.handleTripTypeChange}
                value={MULTI_DESTINATION}
              />{' '}
              Multi-destination
            </TripTypeLabel>
          </Flex>
        </Flex>
        {visibleFlights.map((flight, i) => {
          const indexedItem = dropdownItems?.[i] ?? {}
          const departureDropdownItems = indexedItem?.departureAirport
          const arrivalDropdownItems = indexedItem?.arrivalAirport
          let datePickerAriaLabel = 'Departing – Returning Date Picker'
          if (isOneWay) {
            datePickerAriaLabel = 'Departing Date Picker'
          } else if (isMultiDestination) {
            datePickerAriaLabel = `Departing Date Picker ${i + 1}`
          }

          return (
            <Flex key={i} mx={-2} flexWrap='wrap'>
              <Box width={this.typeaheadWidth} p={2}>
                <ShadowEffect forProperty={`flight-departure-airport${i}`}>
                  {({ disableShadowState }) => (
                    <TypeAheadContainer
                      id={`flight-departure-airport${i}`}
                      type='text'
                      searchItems={departureDropdownItems}
                      dropdownItems={departureDropdownItems}
                      placeholder={startLocationPlaceholder}
                      label={startLocationPlaceholder}
                      allowEmptySelection={!!departureDropdownItems}
                      onTypeAheadChange={e => {
                        onTypeaheadUpdate(i, {
                          departureAirport: e.target.value
                        })
                      }}
                      onItemSelection={(item, event) => {
                        typeaheadFeedback({ ...item, selectedPosition: departureDropdownItems?.indexOf(item) })
                        onTypeaheadSelection(i, {
                          departureAirport: item
                        })
                        disableShadowState()
                        this.navToNextField(event, this.focusDestinationInput)
                      }}
                      isUsingErrorMessage={hasErrors(errors, i, 'departureAirport')}
                      errorMessage={getErrorMessage(errors, i, 'departureAirport')}
                      inputProps={{
                        icon: <Departure color='primary' size={24} />,
                        'data-autobot-element-id': `HOME_FLIGHTS_DEPARTURE_INPUT_${i}`
                      }}
                      initialValue={flight.departureAirport ? flight.departureAirport && flight.departureAirport.itemName : ''}
                      isUsingPopOver
                      selectOnClick
                      render={({
                        rootProps,
                        inputProps,
                        errorProps,
                        dropdownProps,
                        closeDropdown
                      }) => (
                        <Box
                          {...rootProps}
                          aria-label={isMultiDestination ? `Departing From ${i + 1}` : 'Departing From'}
                        >
                          <PopoverContainer
                            open={dropdownProps.showDropdown}
                            onDismiss={e => {
                              const isUsingPopOver = true
                              closeDropdown(isUsingPopOver)
                            }}
                          >
                            <Box
                              role='combobox'
                              aria-expanded={dropdownProps.showDropdown ? 'true' : 'false'}
                              aria-owns='typeahead-list'
                              aria-haspopup='listbox'
                            >
                              <TypeAheadInput
                                {...inputProps} autoHide
                                passedThroughProps={{ 'data-autobot-element-id': `HOME_FLIGHTS_DEPARTURE_INPUT_${i}` }}
                                isLargeInput={isLargeInput} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                                onFocus={e => {
                                  handleOnFocus(`departure ${i}`)
                                  toggleRecent(e)
                                }}
                              />
                              {errorProps.errorMessage && errorProps.isUsingErrorMessage && (
                                <Tooltip {...errorProps}>
                                  {errorProps.errorMessage}
                                </Tooltip>
                              )}
                              <Dropdown {...dropdownProps} minWidth='464px' />
                            </Box>
                          </PopoverContainer>
                        </Box>
                      )}
                    />
                  )}
                </ShadowEffect>
              </Box>
              <Box width={this.typeaheadWidth} p={2}>
                <ShadowEffect forProperty={`flight-arrival-airport${i}`} >
                  {({ disableShadowState }) => (
                    <TypeAheadContainer
                      id={`flight-arrival-airport${i}`}
                      type='text'
                      searchItems={arrivalDropdownItems}
                      dropdownItems={arrivalDropdownItems}
                      placeholder={endLocationPlaceholder}
                      label={endLocationPlaceholder}
                      allowEmptySelection={!!arrivalDropdownItems}
                      onTypeAheadChange={e => {
                        onTypeaheadUpdate(i, {
                          arrivalAirport: e.target.value
                        })
                      }}
                      onItemSelection={(item, event) => {
                        typeaheadFeedback({ ...item, selectedPosition: arrivalDropdownItems?.indexOf(item) })
                        onTypeaheadSelection(i, {
                          arrivalAirport: item
                        })
                        disableShadowState()
                        this.navToNextField(event, this.focusCalendarInput)
                      }}
                      isUsingErrorMessage={hasErrors(errors, i, 'arrivalAirport') && !flight.arrivalAirport}
                      errorMessage={getErrorMessage(errors, i, 'arrivalAirport')}
                      inputProps={{
                        icon: <Arrival color='primary' size={24} />,
                        'data-autobot-element-id': `HOME_FLIGHTS_ARRIVAL_INPUT_${i}`
                      }}
                      initialValue={flight.arrivalAirport ? flight.arrivalAirport && flight.arrivalAirport.itemName : ''}
                      isUsingPopOver
                      selectOnClick
                      render={({
                        rootProps,
                        inputProps,
                        errorProps,
                        dropdownProps,
                        closeDropdown
                      }) => (
                        <Box
                          {...rootProps}
                          aria-label={isMultiDestination ? `Going To ${i + 1}` : 'Going To'}
                        >
                          <PopoverContainer
                            open={dropdownProps.showDropdown}
                            onDismiss={e => {
                              const isUsingPopOver = true
                              closeDropdown(isUsingPopOver)
                            }}
                          >
                            <Box
                              role='combobox'
                              aria-expanded={dropdownProps.showDropdown ? 'true' : 'false'}
                              aria-owns='typeahead-list'
                              aria-haspopup='listbox'
                            >
                              <TypeAheadInput
                                innerRef={elem => { this.destinationInput = elem }}
                                {...inputProps} autoHide
                                passedThroughProps={{ 'data-autobot-element-id': `HOME_FLIGHTS_ARRIVAL_INPUT_${i}` }}
                                isLargeInput={isLargeInput} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                                onFocus={e => {
                                  handleOnFocus(`arrival ${i}`)
                                  toggleRecent(e)
                                }}
                              />
                              {errorProps.errorMessage && errorProps.isUsingErrorMessage && (
                                <Tooltip {...errorProps}>
                                  {errorProps.errorMessage}
                                </Tooltip>
                              )}
                              <Dropdown {...dropdownProps} minWidth='464px' />
                            </Box>
                          </PopoverContainer>
                        </Box>
                      )}
                    />
                  )}
                </ShadowEffect>
              </Box>
              <Flex
                alignItems='center'
                justifyContent='stretch'
                width={[1, null, null, null, 1 / 3]}
                px={2}
                py={2}
              >
                <ShadowEffect forProperty={`flight-date-range${i}`}>
                  {({ disableShadowState }) => (
                    <PopoverContainer
                      key='dates'
                      data-calendar
                      open={calendarOpen === i}
                      position='right'
                      onDismiss={e => {
                        update(closeCalendar)
                        disableShadowState()
                      }}
                      domSelectorForVisuallyContainedElement={CALENDAR_POPOVER_SELECTOR}
                      role='application'
                    >
                      <Box>
                        <DateField
                          innerRef={elem => { this.calendarInput = elem }}
                          aria-label={datePickerAriaLabel}
                          color={getDateFieldBorderColors(errors, i)}
                          m={0}
                          error={dateFieldErrorMessage(errors, i, tripType)}
                          hideTooltip={shouldHideCalendarTooltip(flight, i)}
                          width={1 / 2}
                          id={`flight-date-range${i}`}
                          placeholder={isRoundTrip ? 'Departing – Returning' : 'Departing'}
                          label={isRoundTrip ? 'Departing – Returning' : 'Departing'}
                          value={getDateRange(flight, !isRoundTrip)}
                          data-autobot-element-id='HOME_FLIGHTS_TRAVEL_DATES_INPUT'
                          onClick={e => update(openCalendar(i))}
                          onFocus={e => {
                            update(openCalendar(i))
                            handleCalendarOnFocus(`datefield ${i}`)
                            pclnExperimentation.fireImpression('AIR_HOME_CALENDAR_COLOR_RANGES')
                          }}
                          isLargeInput={isLargeInput} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                          aria-expanded={calendarOpen === i ? 'true' : 'false'}
                          name='flight-date-range'
                        />
                      </Box>
                      <CalendarWrapperBox>
                        <CalendarComponent
                          id={`flight-date-range-calendar-${i}`}
                          onChange={(e, dates) => {
                            this.handleCalendarChange({
                              dates,
                              i,
                              isOneWay,
                              isMultiDestination,
                              isRoundTrip
                            })
                            if (!isRoundTrip || (dates.startDate && dates.endDate)) {
                              disableShadowState()
                            }
                          }}
                          animateScroll
                          minDate={getPrevDate(flights, i)}
                          startDate={flight.departureDate}
                          endDate={isRoundTrip ? flight.arrivalDate : undefined}
                          monthWidthPx={300}
                          selectTwoDates={isRoundTrip}
                          allowSameDay={!includesStay}
                          flightDetails={flightDetails}
                          variantName='EXPRESS'
                          useDefaultFooter={withFooter && !showPriceRangesColor} // TODO: AIR_HOME_CALENDAR_COLOR_RANGES clean up
                          onDismiss={pipe(this.focusCalendarInput, disableShadowState, closeCalendar)}
                          useColorCode={showPriceRangesColor} // TODO: AIR_HOME_CALENDAR_COLOR_RANGES clean up
                        />
                      </CalendarWrapperBox>
                    </PopoverContainer>
                  )}
                </ShadowEffect>
                {i > 0 && (
                  <Hide xs sm>
                    <Close
                      aria-label='remove flight'
                      id='remove-flight-button'
                      ml={2}
                      onClick={e => {
                        e.preventDefault()
                        onRemoveFlight(i)
                      }}
                      title='Remove flight'
                    />
                  </Hide>
                )}
              </Flex>
            </Flex>
          )
        })}

        {isMultiDestination && (
          <Box py={2}>
            <Hide xs sm>
              <Button
                aria-label='add flight'
                disabled={flights.length > 4}
                id='add-flight-button'
                onClick={e => {
                  e.preventDefault()
                  onAddFlight()
                }}
                pl='12px'
                size='medium'
                style={largerInputStyle} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                variation='outline'
              >
                <Flex alignItems='center'>
                  <Plus size={24} />
                  Add another flight
                </Flex>
              </Button>
            </Hide>
            <Hide md lg xl xxl>
              <Flex mx={-1} alignItems='center' justifyContent='stretch'>
                <Button
                  aria-label='add flight'
                  disabled={flights.length > 4}
                  id='mobile-add-flight-button'
                  mx={1}
                  onClick={e => {
                    e.preventDefault()
                    onAddFlight()
                  }}
                  size='small'
                  width={1 / 2}
                  variation='outline'
                >
                  <Plus size={24} />
                </Button>
                <Button
                  aria-label='remove flight'
                  disabled={flights.length < 2}
                  id='mobile-remove-flight-button'
                  mx={1}
                  onClick={e => {
                    e.preventDefault()
                    onRemoveFlight(flights.length - 1)
                  }}
                  size='small'
                  width={1 / 2}
                  variation='outline'
                >
                  <Minus size={24} />
                </Button>
              </Flex>
            </Hide>
          </Box>
        )}

        <Flex
          mx={-2}
          flexWrap={['wrap', null, null, null, 'nowrap']}
          justifyContent={'stretch'}
        >
          <Box
            width={[1, null, 1 / 2, null, !showCabinClass ? 1 / 2 : 1 / 3]}
            p={2}
          >
            <ShadowEffect forProperty='traveler-selection-readonly-input' alternativeBlurHandling>
              {({ disableShadowState }) => (
                <TravelerSelection
                  id='traveler-selection-component'
                  isLargeInput={isLargeInput} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                  isUsingAdultControl
                  isUsingYouthControl
                  isUsingChildControl
                  isUsingRoomControl={productType.includes('STAY')}
                  isUsingLapInfantControl
                  isUsingErrorTooltip
                  initNumRooms={roomCount || 1}
                  initNumAdults={adultsCount || 1}
                  initNumChildren={childrenCount || 0}
                  initNumInfants={infantsCount || 0}
                  initNumYouths={youthsCount || 0}
                  initDisplayLabel='1 Adult'
                  minAdultCount={1}
                  disclaimer={airDisclaimer}
                  error={
                    errors.infantsCount ? 'Priceline does not support infants on international flights.' : '' ||
                    (productType.includes('STAY') && errors.roomCount) ? errors.roomCount.message : ''
                  }
                  handleInputOnFocus={() => handleTravelerSelectionOnFocus('traveler selection')}
                  onDoneButtonClick={disableShadowState}
                  onChange={changedData => {
                    if (typeof onTravelerChange === 'function') {
                      onTravelerChange(changedData)
                    }
                  }}
                />
              )}
            </ShadowEffect>
          </Box>
          {showCabinClass && (
            <Box
              width={[1, null, 1 / 2, null, 1 / 3]}
              p={2}
            >
              <ShadowEffect forProperty='cabin-class-select'>
                <FormField>
                  <Label autoHide htmlFor='cabin-class-select'>
                    Cabin Class
                  </Label>
                  <StyledSelect
                    m={0}
                    id='cabin-class-select'
                    name='cabinClass'
                    aria-label='Cabin Class Select'
                    value={cabinClass}
                    onFocus={() => handleProductFocus('product select')}
                    onChange={e => {
                      const data = { cabinClass: e.target.value }
                      onChange(data)

                      if (handleCabinClassChange) {
                        handleCabinClassChange(data)
                      }
                      e.target.blur()
                    }}
                    children={cabinClasses.map(name => (
                      <option key={name} children={name} />
                    ))}
                    style={largerInputStyle} // TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up
                  />
                </FormField>
              </ShadowEffect>
            </Box>
          )}
          <StyledButtonContainer width={[1, null, !showCabinClass ? 1 / 2 : 1, null, !showCabinClass ? 1 / 2 : 1 / 3]} p={2}>
            <FindYourDealButton
              isLargeInput={isLargeInput} /* TODO: HP_LP_FLIGHTS_LARGER_INPUTS clean up */
              formButtonProps={{ 'data-autobot-element-id': 'HOME_FLIGHTS_SUBMIT_BUTTON' }}
              currentProduct={FLIGHT_PRODUCT_TYPE}
            >
              Find your flight
            </FindYourDealButton>
            <StyledCancelCopy isRoundTrip={isRoundTrip}>
              <Text fontSize={0}>
                Book a flight with free cancellation for flexibility
              </Text>
            </StyledCancelCopy>
          </StyledButtonContainer>
        </Flex>
        <Flex alignItems='center'>
          {isRoundTrip && (<Box mt={2}>
            <ProductTypeCheckbox
              productsOptions={productsOptions}
              onChange={this.handleProductTypeChange}
              selectedProducts={selectedProducts}
              gaCategory={key === 'home' ? ANALYTICS_CATEGORY : ANALYTICS_CATEGORY_FLIGHTS}
              gaLabelPrefix={key === 'home' ? 'flights-' : ''}
            />
          </Box>)}
          {meetsFlexDateCriteria(tripType, selectedProducts) && (
            <ConditionalRender experimentCode='HP_FLIGHT_FLEX_DATES' variantValue='FLEX_DATES'>
              <ConditionalRender.Experiment>
                <Box mt={1} pr={[1, 2, 3, 4]}>
                  <Label fontSize={0} htmlFor='alt-dates'>
                    <Checkbox
                      id='alt-dates'
                      name='alt-dates'
                      value={this.props.isFlexDates}
                      checked={this.props.isFlexDates}
                      onChange={() => {
                        onChange({ isFlexDates: !this.props.isFlexDates })
                      }}
                    />
                    { '+ / - 1 day' }
                  </Label>
                </Box>
              </ConditionalRender.Experiment>
            </ConditionalRender>
          )}
        </Flex>
      </form>
    )
  }
}

function meetsFlexDateCriteria (tripType, selectedProducts) {
  const isRoundTrip = tripType === ROUND_TRIP
  const isOneWay = tripType === ONE_WAY
  return (isRoundTrip || isOneWay) &&
    (selectedProducts.indexOf('STAY') === -1 && selectedProducts.indexOf('DRIVE') === -1)
}

function getErrorMessage (errors, i, key) {
  return hasErrors(errors, i, key)
}

function hasErrors (errors, i, key) {
  return errors && errors.flights && errors.flights[i] && errors.flights[i][key]
    ? errors.flights[i][key].message
    : false
}

function getDateFieldBorderColors (errors, i) {
  return (errors &&
    errors.flights &&
    errors.flights[i] &&
    errors.flights[i].departureDate) ||
    (errors &&
      errors.flights &&
      errors.flights[i] &&
      errors.flights[i].arrivalDate)
    ? 'red'
    : undefined
}

function dateFieldErrorMessage (errors, i, tripType) {
  const isRoundTrip = tripType === ROUND_TRIP
  return (errors &&
    errors.flights &&
    errors.flights[i] &&
    errors.flights[i].departureDate) ||
    (errors &&
      errors.flights &&
      errors.flights[i] &&
      errors.flights[i].arrivalDate)
    ? isRoundTrip ? 'Please select a departing and returning date' : 'Please select a departing date'
    : undefined
}

// dates must be passed to date-picker as YYYYMMDD format
export const getPrevDate = (flights, i) =>
  i > 0 && flights[i - 1].departureDate
    ? moment(flights[i - 1].departureDate).format('YYYYMMDD')
    : moment().format('YYYYMMDD')

FlightsSearchForm.displayName = 'FlightsSearchForm'
export default FlightsSearchForm
